import { useParams, Navigate } from "react-router-dom";
import { SERVICES, UI } from "../data/content";
import { Reveal, HeroBand, SectionHead, ScopeBlock, RelatedLinks, ContactModule, usePageMeta } from "../components/kit";

export default function ServicePage() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  usePageMeta(s ? `${s.name} | KairosHK` : "KairosHK", s?.proposition);
  if (!s) return <Navigate to="/services" replace />;

  return (
    <div data-testid={`service-page-${s.slug}`}>
      <HeroBand image={s.image} eyebrow={UI.nav.services} title={s.name} standfirst={s.proposition} compact />

      <section className="k-section !pb-10">
        <div className="k-container max-w-4xl !mx-0">
          <Reveal>
            {s.preamble.map((p, i) => (
              <p key={i} className={`text-lg leading-relaxed mb-5 ${i > 0 ? "text-ink-muted" : ""}`}>{p}</p>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="k-section !py-14 bg-paper-alt" data-testid="capabilities-section">
        <div className="k-container">
          <SectionHead eyebrow={s.name} title={UI.common.capabilities} />
          <ul className="list-none p-0 m-0 grid md:grid-cols-2 gap-x-12 gap-y-4 max-w-5xl">
            {s.capabilities.map((c, i) => (
              <Reveal key={i} delay={i * 0.03}>
                <li className="flex gap-4 leading-relaxed text-[0.95rem]">
                  <span className="text-brand font-semibold shrink-0">—</span>{c}
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      {s.deliverables && (
        <section className="k-section !py-14" data-testid="deliverables-section">
          <div className="k-container">
            <SectionHead eyebrow={s.name} title={UI.common.deliverables} />
            <Reveal>
              <table className="k-table max-w-4xl" data-testid="deliverables-table">
                <thead><tr><th>{UI.common.deliverable}</th><th>{UI.common.description}</th></tr></thead>
                <tbody>
                  {s.deliverables.map(([d, f]) => (
                    <tr key={d}><td className="font-semibold">{d}</td><td className="text-ink-muted">{f}</td></tr>
                  ))}
                </tbody>
              </table>
            </Reveal>
          </div>
        </section>
      )}

      <section className={`k-section !py-14 ${s.deliverables ? "bg-paper-alt" : ""}`}>
        <div className="k-container">
          <Reveal><ScopeBlock text={s.scope} /></Reveal>
          <Reveal className="mt-12"><RelatedLinks items={s.related} /></Reveal>
        </div>
      </section>

      <section className="k-container pb-20 pt-6">
        <ContactModule />
      </section>
    </div>
  );
}
